import { RenderImageInMarkdown } from "./render-image-in-markdown";

export const RenderImageSections = ({
  className,
  "data-title": title,
  "data-image": image,
  children,
  ...props
}: {
  className?: string;
  "data-title"?: string;
  "data-image"?: string;
  children?: React.ReactNode;
  [key: string]: any;
}) => {
  if (className === "info-section") {
    // Extract the image from children if it exists
    let imageUrl = image;
    let contentChildren = children;

    // Helper function to extract image URL from React elements
    const extractImageUrl = (element: any): string | null => {
      if (element?.props?.src) {
        return element.props.src;
      }

      if (element?.props?.children) {
        if (Array.isArray(element.props.children)) {
          for (const child of element.props.children) {
            const url = extractImageUrl(child);
            if (url) return url;
          }
        } else {
          return extractImageUrl(element.props.children);
        }
      }

      return null;
    };

    // Helper function to check if element contains an image
    const containsImage = (element: any): boolean => {
      if (!element) return false;
      return extractImageUrl(element) !== null;
    };

    // Helper function to check if element is a title
    const isTitle = (element: any): boolean => {
      if (!element) return false;
      if (!title) return false;

      const children = element?.props?.children;
      if (typeof children === "string") {
        return children.includes(title);
      }

      // Handle case where children might be an array or other type
      if (Array.isArray(children)) {
        return children.some(
          (child) => typeof child === "string" && child.includes(title)
        );
      }

      return false;
    };

    if (Array.isArray(children)) {
      // Find and extract image URL
      for (const child of children) {
        const url = extractImageUrl(child);
        if (url) {
          imageUrl = url;
          break;
        }
      }

      // Filter out elements that contain images or are titles
      if (!children) return <div></div>;
      contentChildren = children?.filter(
        (child) => !containsImage(child) && !isTitle(child)
      );
    }

    return (
      <div className="bg-gray-50 rounded-lg overflow-hidden shadow-sm mb-6">
        <div className="md:flex">
          <div className="md:w-1/3 p-4">
            {imageUrl && (
              <RenderImageInMarkdown
                src={imageUrl}
                alt={`Illustration for ${title}`}
                isInTable={false}
              />
            )}
          </div>
          <div className="md:w-2/3 p-6">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">
              {title}
            </h2>
            <div className="prose-sm">{contentChildren}</div>
          </div>
        </div>
      </div>
    );
  }
  return (
    <div className={className} {...props}>
      {children}
    </div>
  );
};
